import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import api from "./services/api";
import VueLodash from "vue-lodash";
import auth from "./services/auth";

auth.handleRedirectPromise().then(async () => {
  if (!auth.isAuthenticated()) {
    await auth.signIn();
  }
  Vue.prototype.$auth = auth;
  Vue.prototype.$http = api;
  Vue.prototype.$eventHub = new Vue();
  
  Vue.config.productionTip = false;
  
  const options = { name: "lodash" };
  Vue.use(VueLodash, options);
  
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
  
})